var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedCurrency, FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import Icon from "@irati/ui/src/Icon";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType";
import { Wrapper, Row, StyledPara } from "./styled";
var RewardWalletRow = /** @class */ (function (_super) {
    __extends(RewardWalletRow, _super);
    function RewardWalletRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.returnRewardWalletBalanceVariables = function (user) { return ({
            currency: authentication.defaultUserCurrency(),
            tenantId: authentication.userTenant().uuid,
            userId: user.uuid
        }); };
        return _this;
    }
    RewardWalletRow.prototype.render = function () {
        var _a = this.props, recipient = _a.recipient, isFirst = _a.isFirst, amount = _a.amount, transferType = _a.transferType;
        var currency = authentication.defaultUserCurrency();
        var fullName = firstnameLastname(recipient);
        return (React.createElement(Wrapper, { isFirst: isFirst },
            React.createElement(RewardWalletBalanceQuery, { fetchPolicy: "no-cache", variables: this.returnRewardWalletBalanceVariables(recipient) }, function (_a) {
                var rewardWallet = _a.data.rewardWallet;
                return (React.createElement(React.Fragment, null,
                    React.createElement(Row, null,
                        React.createElement(StyledPara, { bold: true },
                            transferType === TenantWalletTransferType.TRANSFER &&
                                React.createElement(FormattedMessage, { values: { fullName: fullName }, id: "wallet.tenant.transferConfirmation.transferredTo" }),
                            transferType === TenantWalletTransferType.REFUND &&
                                React.createElement(FormattedMessage, { values: { fullName: fullName }, id: "wallet.tenant.transferConfirmation.refundedFrom" })),
                        React.createElement(StyledPara, { bold: true },
                            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: amount }))),
                    React.createElement(Row, null,
                        React.createElement(StyledPara, { light: true },
                            React.createElement(FormattedMessage, { id: "wallet.tenant.transferConfirmation.rewardWallet" }),
                            React.createElement(Icon, { icon: "wallet" })),
                        React.createElement(StyledPara, { light: true },
                            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: rewardWallet.availableBalance })))));
            })));
    };
    RewardWalletRow.defaultProps = {
        isFirst: false
    };
    return RewardWalletRow;
}(PureComponent));
export default RewardWalletRow;
